module.exports = __webpack_public_path__ + "img/1440.d5f96239.jpg";